import { useEffect, useState } from "react";
import apiLibrary from "services/api";
import { Header } from "./Components/Header";
import { Tabs } from "./Components/Tabs";
import { Toasts } from "view/components/Toasts";
import TextInput from "../MyProfile/Components/Inputs/TextInput";
import usePermissions from "hooks/usePermissions";
import _ from "lodash";
import SIGNLogo from "assets/logo/SIGNLogo";
import ISNSidebarLogo from "assets/logo/ISNSidebarLogo";
import { getAppName } from "hooks/useCustomBranding/constants";
import { DefaultBackGroundImage } from "./Components/DefaultBackGroundImage";
import { BrandBackgroundImages } from "./Components/BrandBackgroundImages";

interface ContactNumber {
  value: string;
  description: string;
  appName: null;
  key: string;
  fileId: null;
  filePath: null;
}

interface Email {
  value: string;
  description: string;
  appName: null;
  key: string;
  fileId: null;
  filePath: null;
}

interface BackgroundImage {
  value: null;
  title: string;
  description: string;
  key: string;
  appName: string;
  fileId: number | null;
  filePath: string | null;
}

interface GracePeriod {
  value: string;
  description: string;
  key: string;
  appName: null;
  fileId: null;
  filePath: null;
}

interface Limit {
  value: string;
  description: string;
  appName: null;
  fileId: null;
  filePath: null;
}

interface ReInvitePeriod {
  value: string;
  description: string;
  key: string;
  appName: null;
  fileId: null;
  filePath: null;
}

interface SettingsState {
  contactNumber: ContactNumber;
  email: Email;
  fishMap: BackgroundImage[];
  gracePeriod: GracePeriod;
  // isn: BackgroundImage[];
  isnAdmin: BackgroundImage[];
  sign: BackgroundImage[];
  limit: Limit;
  reInvitePeriod: ReInvitePeriod;
  skipperScience: BackgroundImage[];
}

export const brandLogos: any = {
  isn_admin: <ISNSidebarLogo width={16} height={16} />,
  sign_admin: <SIGNLogo width={28} height={28} />,
};
export const SyestemSettings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { universalSettings, universalSettingsImages } = usePermissions();
  const currentBrand = getAppName();
  const [currentApp, setCurrentApp] = useState<
    "isn" | "fish_map" | "skipper_science" | "global_settings"
  >("isn");
  const [settings, setSettings] = useState<SettingsState>({
    // isn: [
    //   {
    //     value: null,
    //     description: "",
    //     appName: "isn",
    //     key: "login_page_image",
    //     title: "Login Page",

    //     fileId: null,
    //     filePath: null,
    //   },
    //   {
    //     value: null,
    //     description: "",
    //     appName: "isn",
    //     key: "forget_password_page_image",
    //     title: "Forgot Password Page",
    //     fileId: null,
    //     filePath: null,
    //   },
    // ],
    isnAdmin: [
      {
        value: null,
        description: "",
        appName: "isn_admin",
        key: "login_page_image",
        title: "Login Page ",

        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "isn_admin",
        key: "forget_password_page_image",
        title: "Forgot Password Page ",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "isn_admin",
        key: "observer_mobile_dashboard_image",
        title: "Observer Mobile Dashboard",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "isn_admin",
        key: "observer_offline_checklist_image",
        title: "Observer Offline Checklist",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "isn_admin",
        key: "observer_dashboard_web_image",
        title: "Observer Dashboard Web",
        fileId: null,
        filePath: null,
      },
    ],
    skipperScience: [
      {
        value: null,
        description: "",
        appName: "skipper_science",
        key: "login_page_image",
        title: "Login Page",

        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "skipper_science",
        key: "forget_password_page_image",
        title: "Forgot Password Page",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "skipper_science",
        key: "observer_mobile_dashboard_image",
        title: "Observer Mobile Dashboard",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "skipper_science",
        key: "observer_offline_checklist_image",
        title: "Observer Offline Checklist",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "skipper_science",
        key: "observer_dashboard_web_image",
        title: "Observer Dashboard Web",
        fileId: null,
        filePath: null,
      },
    ],
    fishMap: [
      {
        value: null,
        description: "",
        appName: "fish_map",
        key: "login_page_image",
        title: "Login Page",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "fish_map",
        key: "forget_password_page_image",
        title: "Forgot Password Page",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "fish_map",
        key: "observer_mobile_dashboard_image",
        title: "Observer Mobile Dashboard",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "fish_map",
        key: "observer_offline_checklist_image",
        title: "Observer Offline Checklist",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "fish_map",
        key: "observer_dashboard_web_image",
        title: "Observer Dashboard Web",
        fileId: null,
        filePath: null,
      },
    ],
    sign: [
      {
        value: null,
        description: "",
        appName: "sign",
        key: "login_page_image",
        title: "Forgot Password Page",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "sign",
        key: "forget_password_page_image",
        title: "Forgot Password Page",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "sign",
        key: "observer_mobile_dashboard_image",
        title: "Observer Mobile Dashboard",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "sign",
        key: "observer_offline_checklist_image",
        title: "Observer Offline Checklist",
        fileId: null,
        filePath: null,
      },
      {
        value: null,
        description: "",
        appName: "sign",
        key: "observer_dashboard_web_image",
        title: "Observer Dashboard Web",
        fileId: null,
        filePath: null,
      },
    ],
    limit: {
      value: "",
      description: "limit",
      appName: null,
      fileId: null,
      filePath: null,
    },
    contactNumber: {
      value: "",
      description: "",
      appName: null,
      key: "contact_number",
      fileId: null,
      filePath: null,
    },
    email: {
      value: "",
      description: "",
      appName: null,
      key: "email",
      fileId: null,
      filePath: null,
    },
    gracePeriod: {
      value: "",
      description: "",
      appName: null,
      key: "grace_period",
      fileId: null,
      filePath: null,
    },

    reInvitePeriod: {
      value: "",
      description: "",
      appName: null,
      key: "re_invite_period",
      fileId: null,
      filePath: null,
    },
  });
  const getUniversalSettings = async () => {
    try {
      const { data } = await apiLibrary.systemSettings.getUniversalSettings();

      setSettings((prevSettings) => ({
        ...prevSettings,
        ...data,
        // isn: updateAndCheckBackgroundImages(data.isn, "isn"),
        isnAdmin: updateAndCheckBackgroundImages(data.isnAdmin, "isn_admin"),
        skipperScience: updateAndCheckBackgroundImages(
          data.skipperScience,
          "skipper_science"
        ),
        fishMap: updateAndCheckBackgroundImages(data.fishMap, "fish_map"),
        sign: updateAndCheckBackgroundImages(data?.sign, "sign"),
      }));
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error.message;
      Toasts.error(errorMsg);

      console.error("Error fetching universal settings:", error);
    }
  };

  useEffect(() => {
    getUniversalSettings();
  }, []);

  console.log(
    settings?.fishMap.filter((item: BackgroundImage) =>
      ["login_page_image", "forget_password_page_image"].includes(item.key)
    )
  );
  const updateUniversalSettings = async (
    setting: any,
    gracePeriodValue: any,
    reInvitePeriodValue: any
  ) => {
    if (!universalSettings.canEditUniversalSettings) {
      return;
    } else {
      setIsLoading(true);
      try {
        const { data, message } =
          await apiLibrary.systemSettings.updateUniversalSettings(
            setting,
            gracePeriodValue,
            reInvitePeriodValue
          );
        setSettings(data);
        getUniversalSettings();
        Toasts.success(message);
      } catch (error: any) {
        const errorMsg = error.response.data.message ?? error.message;
        Toasts.error(errorMsg);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="flex flex-col items-start justify-start w-full pt-4 pb-20">
      <div className="flex flex-col items-start justify-start flex-grow-0 flex-shrink-0 w-full gap-3">
        <Header />
        <Tabs currentApp={currentApp} setCurrentApp={setCurrentApp} />
        <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-10 px-6 pt-6 pb-10 rounded-lg bg-bgWhite dark:bg-secondaryLight">
          {universalSettingsImages.canViewUniversalSettingsImages &&
            currentApp !== "global_settings" && (
              <div className="flex flex-col items-start pb-4 self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4">
                <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4">
                  <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative pt-1.5">
                    <p className="self-stretch flex-grow-0 flex-shrink-0 w-[1472px] text-base font-semibold text-left text-secondaryMid dark:text-textMain">
                      Background images configuration
                    </p>
                    <p className="text-sm text-left text-textMidLight dark:text-textMain">
                      Click the Preview 1:1 button to view your page in
                      full-scale size, as the small preview is only an
                      approximation. For the best results on all devices, use an
                      image that’s at least 1920 x 1024 pixels.
                    </p>
                  </div>

                  <BrandBackgroundImages
                    currentBrand={currentBrand}
                    currentApp={currentApp}
                    settings={settings}
                    getUniversalSettings={getUniversalSettings}
                  />
                  <DefaultBackGroundImage
                    currentBrand={currentBrand}
                    currentApp={currentApp}
                    settings={settings}
                    getUniversalSettings={getUniversalSettings}
                    setSettings={setSettings}
                  />

                  <span className="mt-10 text-sm text-textMidLight dark:text-textMain">
                    You can crop, resize or edit your image at{" "}
                    <a
                      className="font-medium text-primary"
                      href="https://www.iloveimg.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      iloveimg.com
                    </a>.
                  </span>

                  {/* <div className='flex flex-wrap items-start justify-start w-full gap-4'>
                  {settings?.sign?.map(
                    (setting: BackgroundImage, index: number) => {
                      return (
                        <ImagePreview
                          title={setting?.title}
                          description={setting?.description}
                          fileId={setting?.fileId}
                          appName={setting?.appName}
                          filePath={setting?.filePath}
                          imageKey={setting?.key}
                          value={setting?.value}
                          getUniversalSettings={getUniversalSettings}
                        />
                      );
                    }
                  )}
                </div> */}
                </div>
              </div>
            )}
          {universalSettings.canViewUniversalSettings &&
            currentApp === "global_settings" && (
              <>
                <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4">
                  <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4">
                    <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative pt-1.5">
                      <p className="text-base font-semibold text-left text-secondaryMid dark:text-textMain">
                        Grace period
                      </p>
                      <p className="text-sm text-left text-textMidLight dark:text-textMain">
                        Set the amount of time before an admin user is
                        automatically logged out.
                      </p>
                    </div>
                    <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 w-[280px]">
                      <TextInput
                        startAdornment={
                          <div className="mr-3">
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              preserveAspectRatio="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10 5C10.5523 5 11 5.44772 11 6V9.58579L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L9.29289 10.7071C9.10536 10.5196 9 10.2652 9 10V6C9 5.44772 9.44771 5 10 5Z"
                                className="fill-[#2C3236] dark:fill-[#ffffff]"
                              />
                            </svg>
                          </div>
                        }
                        disabled={
                          isLoading ||
                          !universalSettings.canEditUniversalSettings
                        }
                        value={settings?.gracePeriod.value}
                        fieldAs="select"
                        label=" "
                        type="select"
                        name=""
                        data={[
                          "12 hours",
                          "24 hours",
                          "2 days",
                          "5 days",
                          "1 week",
                          "2 weeks",
                          "1 month",
                          "2 months",
                        ]}
                        handleChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          updateUniversalSettings(
                            settings?.gracePeriod.key,
                            event.target.value,
                            settings?.reInvitePeriod.value
                          );
                          // const lowerCase = event.target.value.toLocaleLowerCase();
                          // setFieldValue("occurrence.repeatUnit", lowerCase);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4">
                  <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4">
                    <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative pt-1.5">
                      <p className="text-base font-semibold text-left text-secondaryMid dark:text-textMain">
                        Re-Invite period
                      </p>
                      <p className="text-sm text-left text-textMidLight dark:text-textMain">
                        Set the automatic period of time before a user will
                        receive a reinvitation to join the system.
                      </p>
                    </div>
                    <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 w-[280px]">
                      <TextInput
                        startAdornment={
                          <div className="mr-3">
                            <svg
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
                              preserveAspectRatio="xMidYMid meet"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M8 2C8.55228 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4H19C20.6569 4 22 5.34315 22 7V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V7C2 5.34315 3.34315 4 5 4H7V3C7 2.44772 7.44772 2 8 2ZM7 6H5C4.44772 6 4 6.44772 4 7V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V7C20 6.44772 19.5523 6 19 6H17V7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7V6H9V7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7V6ZM6 11C6 10.4477 6.44772 10 7 10H17C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12H7C6.44772 12 6 11.5523 6 11Z"
                                className="fill-[#2C3236] dark:fill-[#ffffff]"
                              />
                            </svg>
                          </div>
                        }
                        disabled={
                          isLoading ||
                          !universalSettings.canEditUniversalSettings
                        }
                        value={settings?.reInvitePeriod.value}
                        fieldAs="select"
                        label=" "
                        type="select"
                        name=""
                        data={[
                          "7 days",
                          "2 weeks",
                          "1 month",
                          "2 months",
                          "3 months",
                          "4 months",
                          "6 months",
                          "1 year",
                        ]}
                        handleChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          updateUniversalSettings(
                            settings?.reInvitePeriod.key,
                            settings?.gracePeriod.value,
                            event.target.value
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
      </div>
    </div>
  );
};

export default SyestemSettings;

function updateAndCheckBackgroundImages(
  settings: BackgroundImage[],
  appName: string
): BackgroundImage[] {
  if (!Array.isArray(settings)) {
    return [
      {
        value: null,
        description: "",
        appName,
        key: "login_page_image",
        fileId: null,
        filePath: null,
        title: "Login Page",
      },
      {
        value: null,
        description: "",
        appName,
        key: "forget_password_page_image",
        fileId: null,
        filePath: null,
        title: "Forgot Password Page",
      },
      {
        value: null,
        description: "",
        appName,
        key: "observer_mobile_dashboard_image",
        fileId: null,
        filePath: null,
        title: "Observer Mobile Dashboard",
      },
      {
        value: null,
        description: "",
        appName,
        key: "observer_offline_checklist_image",
        fileId: null,
        filePath: null,
        title: "Observer Offline Checklist",
      },
      {
        value: null,
        description: "",
        appName,
        key: "observer_dashboard_web_image",
        fileId: null,
        filePath: null,
        title: "Observer Dashboard Web",
      },
    ];
  }

  const defaults = {
    login_page_image: {
      value: null,
      description: "",
      appName,
      key: "login_page_image",
      fileId: null,
      filePath: null,
      title: "Login Page",
    },
    forget_password_page_image: {
      value: null,
      description: "",
      appName,
      key: "forget_password_page_image",
      fileId: null,
      filePath: null,
      title: "Forgot Password Page",
    },
    observer_mobile_dashboard_image: {
      value: null,
      description: "",
      appName,
      key: "observer_mobile_dashboard_image",
      fileId: null,
      filePath: null,
      title: "Observer Mobile Dashboard",
    },
    observer_offline_checklist_image: {
      value: null,
      description: "",
      appName,
      key: "observer_offline_checklist_image",
      fileId: null,
      filePath: null,
      title: "Observer Offline Checklist",
    },
    observer_dashboard_web_image: {
      value: null,
      description: "",
      appName,
      key: "observer_dashboard_web_image",
      fileId: null,
      filePath: null,
      title: "Observer Dashboard Web",
    },
  };

  const titleByKey: Record<string, string> = {
    login_page_image: "Login Page",
    forget_password_page_image: "Forgot Password Page",
    observer_mobile_dashboard_image: "Observer Mobile Dashboard",
    observer_offline_checklist_image: "Observer Offline Checklist",
    observer_dashboard_web_image: "Observer Dashboard Web",
  };

  const updatedSettings = _(settings)
    .reject({ key: "verification_page_image" })
    .map((setting) => ({
      ...setting,
      title: titleByKey[setting.key] ?? "",
    }))
    .value();

  _.forEach(defaults, (value, key) => {
    if (!_.find(updatedSettings, { key })) {
      updatedSettings.push(value);
    }
  });

  return _.sortBy(updatedSettings, [
    (setting) => setting.key !== "login_page_image",
    (setting) => setting.key !== "forget_password_page_image",
    (setting) => setting.key !== "observer_mobile_dashboard_image",
    (setting) => setting.key !== "observer_offline_checklist_image",
    (setting) => setting.key !== "observer_dashboard_web_image",
  ]);
}

// function updateAndCheckBackgroundImages(
//   settings: BackgroundImage[],
//   appName: string
// ): BackgroundImage[] {
//   if (!Array.isArray(settings)) {
//     return [
//       {
//         value: null,
//         description: "",
//         appName: "",
//         key: "login_page_image",
//         fileId: null,
//         filePath: null,
//         title: "Login Page",
//       },
//       {
//         value: null,
//         description: "",
//         appName: "",
//         key: "forget_password_page_image",
//         fileId: null,
//         filePath: null,
//         title: "Forgot Password Page",
//       },
//     ];
//   }

//   const defaults = {
//     login_page_image: {
//       value: null,
//       description: "",
//       appName: "",
//       key: "login_page_image",
//       fileId: null,
//       filePath: null,
//       title: "Login Page",
//     },
//     forget_password_page_image: {
//       value: null,
//       description: "",
//       appName: "",
//       key: "forget_password_page_image",
//       fileId: null,
//       filePath: null,
//       title: "Forgot Password Page",
//     },
//   };

//   const updatedSettings = _(settings)
//     .reject({ key: "verification_page_image" })
//     .map((setting) => ({
//       ...setting,
//       title:
//         setting.key === "login_page_image"
//           ? "Login Page"
//           : setting.key === "forget_password_page_image"
//             ? "Forgot Password Page"
//             : "",
//     }))
//     .value();

//   _.forEach(defaults, (value, key) => {
//     if (!_.find(updatedSettings, { key })) {
//       updatedSettings.push(value);
//     }
//   });

//   return _.sortBy(updatedSettings, [
//     (setting) => setting.key !== "login_page_image",
//     (setting) => setting.key !== "forget_password_page_image",
//   ]);
// }

/* <ImagePreview
  title="Verification Code Page"
  description={settings?.verificationPageImage?.description}
  fileId={settings?.verificationPageImage?.fileId}
  filePath={settings?.verificationPageImage?.filePath}
  imageKey={settings?.verificationPageImage?.key}
  value={settings?.verificationPageImage?.value}
  getUniversalSettings={getUniversalSettings}
/> */
